import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get grnAdditionalCost
export const getGrnAdditionalCost = createAsyncThunk(
  "grnAdditionalCost/getGrnAdditionalCost",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo } = params;
      const { data } = await API.getGrnAdditionalCost({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all grnAdditionalCost
export const getAllGrnAdditionalCost = createAsyncThunk(
  "grnAdditionalCost/getAllGrnAdditionalCost",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllGrnAdditionalCost();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("grnAdditionalCost/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("grnAdditionalCost/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "grnAdditionalCost/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageGrnAdditionalCost({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get by id
export const getGrnAdditionalCostById = createAsyncThunk(
  "grnAdditionalCost/getGrnAdditionalCostById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getGrnAdditionalCostById(id);

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create grnAdditionalCost
export const createGrnAdditionalCost = createAsyncThunk(
  "grnAdditionalCost/createGrnAdditionalCost",
  async (params, { rejectWithValue }) => {
    const { name, accountGroup, rate, amount, sign, branch, isActive } = params;
    try {
      const body = JSON.stringify({ name, accountGroup, rate, amount, sign, branch, isActive });
      const { data } = await API.createGrnAdditionalCost(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateGrnAdditionalCost = createAsyncThunk(
  "grnAdditionalCost/updateGrnAdditionalCost",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const { name, accountGroup, rate, amount, sign, branch, isActive } = values;
    try {
      const body = JSON.stringify({ name, accountGroup, rate, amount, sign, branch, isActive });
      const { data } = await API.updateGrnAdditionalCost(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("grnAdditionalCost/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
